import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleSwitchComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ToggleSwitchComponent implements ControlValueAccessor {


    _onIcon: any = ['fas', 'check'];

    @Input()
    public get onIcon(): any {
        if (this._onIcon === undefined) { return ['fas', 'check']; };

        return this._onIcon;
    }

    public set onIcon(value: any) {
        this._onIcon = value;
    }


    _offIcon: any = ['fas', 'times'];

    @Input()
    public get offIcon(): any {
        if (this._offIcon === undefined) { return ['fas', 'times']; }

        return this._offIcon;
    }

    public set offIcon(value: any) {
        this._offIcon = value;
    }

    @Input() label: string = '';
    @Input() color?: string;
    @Input() disabled = false;
    @Input() size: 'default' | 'sm' = 'default';
    @Output() change = new EventEmitter<{ checked: boolean }>();

    onChange: any = () => { };
    onTouch: any = () => { };
    private _value = false;

    @Input()
    set value(val) {
        this._value = !!val;
        this.cd.markForCheck();
    }
    get value(): boolean {
        return this._value;
    }

    @Input()
    set checked(val: boolean) {
        this.value = val;
    }
    get checked(): boolean {
        return this.value;
    }

    writeValue(value: any): void {
        this._value = !!value;
        this.cd.markForCheck();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cd.markForCheck();
    }

    constructor(private cd: ChangeDetectorRef) { }

    onToggle(checked: boolean): void {
        if (this.disabled) {
            return;
        }

        this._value = checked;
        this.onChange(checked);
        this.onTouch();
        this.change.emit({ checked });
        this.cd.markForCheck();
    }


}
